<app-common-modal [alignTitleCenter]="false">
  <div
    class="mobile-device-warning header grid-container-content-horizontal-center"
    modalHeader
  >
    <div class="mat-body-1 m-0 font-weight-medium">
      Sleip Desktop is designed for desktop and tablet browsers
    </div>
  </div>
  <div class="mobile-device-warning content">
    <p class="m-0 sub-text">
      If you want to use Sleip on your phone please download the iOS app from
      App Store.
    </p>
  </div>
  <div class="mobile-device-warning" modalFooterActions>
    <button
      class="sleip-tertiary-button large-size-button button-no-hover-effect button-block"
      (click)="onCancel()"
      mat-flat-button
    >
      Close
    </button>
  </div>
</app-common-modal>
